const style = {
  wrapper: {
    marginTop: `15px`
  },
  link: {
    // color: `#A94545`,
    color: `black`,
    fontSize: `14px`,
    display: `block`,
    width: `100%`,
    padding: `10px 15px`,
    // borderBottom: `1px solid #ddd`,
    textDecoration: `none`,
    ':hover': {
      background: `#f7f7f7`
    }
  },
  activeLink: {
    background: `#f7f7f7`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/Sidebar/style/navigation.js